// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hwyvddEa","footer":"u7bWGsfA","lowLinks":"_6UnsngEz"};